import React, {useMemo} from 'react';
import type {FC, PropsWithChildren} from 'react';

import type {CardBaseProps, LinkProps, ImageProps} from '@gravity-ui/page-constructor';
import {CardBase, Links, YFMWrapper} from '@gravity-ui/page-constructor';

import './PromoPageCard.scss';

import {cnPromoPageCard} from './PromoPageCard.classname';

interface CardData {
    header?: {
        title?: string;
        image?: ImageProps;
    };
    text?: string;
    link?: LinkProps;
    links?: LinkProps[];
}
type PromoPageCardProps = PropsWithChildren<CardBaseProps & CardData>;

export const PromoPageCard: FC<PromoPageCardProps> = (props) => {
    const {
        text,
        header: {image, title: headerTitle} = {},
        link,
        links = [],
        border,
        children,
    } = props;

    const allLinks = useMemo(() => (link ? [link, ...links] : links), [links, link]);

    return (
        <CardBase className={cnPromoPageCard()} border={border}>
            <CardBase.Header image={image} className={cnPromoPageCard('Header')}>
                {headerTitle && (
                    <h4 className={cnPromoPageCard('Title')}>
                        <HTML>{headerTitle}</HTML>
                    </h4>
                )}
            </CardBase.Header>
            <CardBase.Content>
                {text && (
                    <YFMWrapper
                        content={text}
                        modifiers={{
                            constructor: true,
                            constructorListStyle: true,
                        }}
                    />
                )}
                {children}
            </CardBase.Content>
            <CardBase.Footer>
                <Links links={allLinks} />
            </CardBase.Footer>
        </CardBase>
    );
};

interface HTMLProps {
    children?: string;
    block?: boolean;
    className?: string;
}

const HTML: React.FC<HTMLProps> = ({children, block = false, className}) => {
    if (!children) {
        return null;
    }

    return React.createElement(block ? 'div' : 'span', {
        dangerouslySetInnerHTML: {__html: children},
        className,
    });
};
